module.exports = __webpack_public_path__ + "static/media/tree_6.3ddd671e.svg";